import { fromJS } from 'immutable';
import { createSelector } from 'reselect';
import { Logout as LogoutApi } from '../../api';
import { LOGIN_ROUTE } from '../../constants/routes';
import { removeTokens, getAuthToken } from '../../providers/authTokenProvider';

// ACTION TYPES
export const RESET_APPLICATION = 'customer-portal/authentication/RESET_APPLICATION';
export const LOGGING_OUT = 'customer-portal/authentication/LOGGING_OUT';
export const USER_LOGIN = 'customer-portal/authentication/USER_LOGIN';
export const COOKIE_LOGIN = 'customer-portal/authentication/COOKIE_LOGIN';

// ACTION CREATORS
export const loggedOutActionCreator = () => ({
  type: RESET_APPLICATION,
});

export const logoutActionCreator = () => ({
  type: LOGGING_OUT,
});

export const logIn = payload => ({
  type: USER_LOGIN,
  payload,
});

export const cookieLogin = payload => ({
  type: COOKIE_LOGIN,
  payload,
});

// THUNKS
export const logout = history => async dispatch => {
  // reset the redux state to pristine
  dispatch(logoutActionCreator());

  // call the logout endpoint
  // If they are already logged out in another tab,
  // this API will fail because the auth token should be gone
  try {
    if (getAuthToken()) {
      await LogoutApi();
    }
  } finally {
    // remove any cookies
    removeTokens();

    dispatch(loggedOutActionCreator());

    // Potentially empty history object if this was dispatched from middleware
    history?.push(LOGIN_ROUTE);
  }
};

export const initialState = fromJS({
  isLoggedIn: false,
  accessToken: null,
  refreshToken: null,
  loggingOut: false,
});

// SELECTORS
const authenticationSelector = state => state.authentication;

export const isLoggedIn = createSelector([authenticationSelector], authentication => authentication?.get('isLoggedIn') || false);

export const isLoggingOut = createSelector([authenticationSelector], authentication => authentication?.get('loggingOut') || false);

// REDUCER
export default (state = initialState, action) => {
  switch (action.type) {
    case USER_LOGIN: {
      const newState = state.set('isLoggedIn', true);
      return newState.merge(action.payload.data);
    }
    case COOKIE_LOGIN: {
      return state
        .set('isLoggedIn', true)
        .set('accessToken', action.payload.accessToken)
        .set('refreshToken', action.payload.refreshToken || null);
    }
    case LOGGING_OUT:
      return state.set('loggingOut', true).set('isLoggedIn', false);
    default:
      return state;
  }
};
